import React, { Component } from 'react';
import IconButton from '../Buttons/IconButton/IconButton';
import { TString } from '../Response/Utils';

interface Props {
  notifications: any;
  closeNotification: Function;
  toggleOverlay: Function;
  langCode: string;
}

class Notifications extends Component<Props> {
  constructor(props) {
    super(props);
  }

  addNewTab = data => {
    var regex1 = /a href="http/gi;
    var regex2 = /a href="www/gi;
    let x = data
      .replace(regex1, "a target='_blank' href=\"http")
      .replace(regex2, "a target='_blank' href=\"www");
    return x;
  };

  render() {
    return (
      <React.Fragment>
        {this.props.notifications &&
          this.props.notifications.map((e: any, i: number) => {
            return (
              <div
                tabIndex={0}
                className={`sf-each-offer ${
                  e.notificationType !== 'normal' ? 'clickable' : ''
                } `}
                key={i}
                style={{ wordBreak: 'break-word' }}
              >
                <IconButton
                  variant={'filled'}
                  size={'small'}
                  className="clickable card-close"
                  onClick={() =>
                    this.props.closeNotification(e.notificationId, e.userId)
                  }
                  title={TString({
                    labelName: 'dismissLabel',
                    langCode: this.props.langCode,
                    fromClass: true
                  })}
                  image={'close'}
                />

                <div
                  onClick={() => {
                    if (e.notificationType === 'autoSubmit') {
                      this.props.closeNotification(e.notificationId, e.userId);
                      window['autosubmit'](
                        e.notificationAction || e.notificationMsg
                      );
                      this.props.toggleOverlay();
                    }
                  }}
                  className="each-offer-card-title"
                >
                  {e.notificationTitle}
                </div>
                <div className="each-offer-card-msg">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.addNewTab(e.notificationMsg)
                    }}
                  />
                </div>
              </div>
            );
          })}
      </React.Fragment>
    );
  }
}

export default Notifications;
